import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FolioService } from '../../../services/folio.service';

/**
 * <app-folio-pill> — píldora de folio de interacción reutilizable (Fase C0).
 *
 * Muestra el folio en fuente monoespaciada con el estilo AC (azul) u OP
 * (verde/morado) y un botón para copiarlo al portapapeles. Opcionalmente
 * muestra las horas asociadas (solo si `showHours`).
 */
@Component({
  selector: 'app-folio-pill',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './folio-pill.component.html',
  styleUrls: ['./folio-pill.component.scss'],
})
export class FolioPillComponent {
  @Input() folio = '';
  @Input() interactionType: 'AC' | 'OP' = 'AC';
  @Input() showHours = true;
  @Input() hours?: number;

  protected readonly folioService = inject(FolioService);

  get pillClass(): string {
    return this.interactionType === 'OP' ? 'folio-pill-op' : 'folio-pill-ac';
  }

  get isCopied(): boolean {
    return this.folioService.lastCopied() === this.folio;
  }

  onCopy(event: Event): void {
    this.folioService.copyFolio(this.folio, event);
  }
}
